import { Vyhodnotenie as VyhodnotenieGenerated, VyhodnotenieApi } from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import ClassType, { classTypeToGenerated } from '../model/pripomienka/ClassType';
import AddVyhodnotenie from '../model/pripomienka/AddVyhodnotenie';
import { stavPripomienkyToGenerated } from '../model/pripomienka/StavPripomienky';
import Uuid from '../model/Uuid';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new VyhodnotenieApi(apiConfiguration(pripomienkyPrefixPath));

const map = (vyhodnotenie: AddVyhodnotenie): VyhodnotenieGenerated => ({
  stavPripomienky: stavPripomienkyToGenerated(vyhodnotenie.stavPripomienky),
  textVyhodnotenia: vyhodnotenie.textVyhodnotenia,
});

// eslint-disable-next-line import/prefer-default-export
export const addVyhodnotenie = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  uuid: string,
  vyhodnotenie: AddVyhodnotenie,
  options?: AxiosRequestConfig,
):
    Promise<ClientResponse<Uuid>> => {
  const {
    data,
    status,
  } = await client.vyhodnotenie(
    classTypeToGenerated(classType),
    type,
    year,
    index,
    uuid,
    map(vyhodnotenie),
    options,
  );
  return {
    data: data.uuid,
    responseCode: status,
  };
};
